export const parseFilterDate = (value, endOfDay = false) => {
  if (!value) return null;

  const dateValue = /^\d{4}-\d{2}-\d{2}$/.test(String(value))
    ? `${value}T${endOfDay ? "23:59:59.999" : "00:00:00"}`
    : value;
  const date = new Date(dateValue);

  return Number.isNaN(date.getTime()) ? null : date;
};

export const parsePartnerTimestamp = (value) => {
  if (value === null || value === undefined || value === "") return null;

  const numericValue = Number(value);
  const date = Number.isFinite(numericValue)
    ? new Date(
        Math.abs(numericValue) < 1_000_000_000_000
          ? numericValue * 1000
          : numericValue,
      )
    : new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
};

export const isInvalidDateRange = (from, to) => {
  if (!from || !to) return false;

  const fromDate = parseFilterDate(from);
  const toDate = parseFilterDate(to, true);
  return !fromDate || !toDate || fromDate > toDate;
};
